/* ADD SOFTSKILL COURSE */
export const ADD_SOFTSKILL_COURSE = "ADD_SOFTSKILL_COURSE"
export const ADD_SOFTSKILL_COURSE_SUCCESS = "ADD_SOFTSKILL_COURSE_SUCCESS"
export const ADD_SOFTSKILL_COURSE_CLEAN = "ADD_SOFTSKILL_COURSE_CLEAN"
export const ADD_SOFTSKILL_COURSE_ERROR = "ADD_SOFTSKILL_COURSE_ERROR"
